import {CopyToClipboardButton} from '@github-ui/copy-to-clipboard/Button'
import {Dialog} from '@primer/react'

import styles from './ConnectDeviceDialog.module.css'

const REMOTE_COMMAND = 'copilot --remote'
const SLASH_COMMAND = '/remote on'

type ConnectDeviceDialogProps = {
  onClose: () => void
}

export function ConnectDeviceDialog({onClose}: ConnectDeviceDialogProps) {
  return (
    <Dialog onClose={onClose} width="large" title="Use Copilot in the CLI">
      <div className={styles.body}>
        <p className={styles.description}>Start Copilot in the CLI and connect it to the web or mobile, simply run</p>
        <div className={styles.codeWrapper}>
          <code className={styles.code}>{REMOTE_COMMAND}</code>
          <CopyToClipboardButton textToCopy={REMOTE_COMMAND} variant="invisible" ariaLabel="Copy command" />
        </div>
        <p className={styles.footnote}>
          or type <span className={styles.footnoteCommand}>{SLASH_COMMAND}</span> in a running session
        </p>
      </div>
    </Dialog>
  )
}
